import * as d3 from 'd3-selection'

export default function (selection, attachTo) {
  selection.each(function (data) {
    var caret = d3.select(this)
                  .selectAll('.caret')
                  .data(function (d) {
                    return !d.multiple ? [true] : []
                  })

    caret.enter()
         .append('div')
           .attr('class', 'caret')
           .append('b')
    caret.exit().remove()
  })
}
